import React, { useEffect, useState } from 'react';
import { useAtomValue, useSetAtom } from 'jotai';
import Box from '@mui/material/Box';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import { CloseSummaryIcon, SummaryBackgroundStyle } from './styles';
import { primary } from '@/theme/colors';
import { applyFilters as applyFiltersState } from '@/components/Analysis/state';
import { QuerySummary } from './QuerySummary';
import * as state from '@/components/Analysis/state';
import { NewComponent } from '../NewComponent';
import { useFeatureFlag, useHavePermission } from '@/hooks';
import { DataFixingUploadsButton } from '../DataFixingUploads';
import { Permissions } from '@/types';
import { EquipmentExportXlsx } from '../EquipmentExport/EquipmentExportXlsx';
import { PlatformSettings } from '../PlatformSettings';

export const QueryReport = () => {
  const [openAccordion, setOpenAccordion] = useState(true);
  const setApplyFilters = useSetAtom(applyFiltersState);
  const template = useAtomValue(state.assemblyTemplate);
  const canEditWallLossFactor = useHavePermission(Permissions.UPDATE_WALL_LOSS_FACTOR);

  useEffect(() => {
    setApplyFilters(openAccordion);
  }, [openAccordion, setApplyFilters]);
  const isBetaUser = useFeatureFlag('beta-user');

  // Only Admin and AIT Task Lead can view Pipe Spec Upload and Service Group Upload
  const isAdminOrTaskLead = useFeatureFlag(['admin', 'ait-task-lead']);

  const handleAccordionClick = () => {
    setOpenAccordion(!openAccordion);
  };

  return (
    <Box
      sx={{
        mb: 3,
        '& .MuiAccordion-root:before': {
          display: 'none',
        },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        {template?.querySummary && template.querySummary.length > 0 && (
          <Typography
            sx={{
              fontWeight: '700',
              fontSize: '1.6rem',
              color: primary.darkBlue,
              lineHeight: 'normal',
            }}
          >
            Query Results
          </Typography>
        )}
        <Box
          sx={{
            ml: 'auto',
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            marginY: 2,
          }}
        >
          {(canEditWallLossFactor || isAdminOrTaskLead) && <PlatformSettings />}
          <EquipmentExportXlsx />
          {isAdminOrTaskLead && <DataFixingUploadsButton />}
          {isBetaUser && <NewComponent />}
        </Box>
      </Box>
      {template?.querySummary && template.querySummary.length > 0 && (
        <Accordion
          disableGutters
          expanded={openAccordion}
          sx={SummaryBackgroundStyle}
          elevation={0}
          square
        >
          <AccordionSummary
            expandIcon={<CloseSummaryIcon isOpen={openAccordion} />}
            onClick={handleAccordionClick}
          >
            <Typography variant="body2" fontWeight={500}>
              Query Summary
            </Typography>
          </AccordionSummary>
          {openAccordion && <QuerySummary />}
        </Accordion>
      )}
    </Box>
  );
};
